__turbopack_context__.v({
  "bodyText": "atoms-module__1rH-Ya__bodyText",
  "copyBlock": "atoms-module__1rH-Ya__copyBlock",
  "dharmaHeading": "atoms-module__1rH-Ya__dharmaHeading",
  "dharmaTitleWrapper": "atoms-module__1rH-Ya__dharmaTitleWrapper",
  "sectionBg": "atoms-module__1rH-Ya__sectionBg",
  "sectionContent": "atoms-module__1rH-Ya__sectionContent",
  "sectionWithBg": "atoms-module__1rH-Ya__sectionWithBg",
  "srOnly": "atoms-module__1rH-Ya__srOnly",
});
